
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import Icon from 'components/Icon'
import {TooltipTable, TooltipRow, TooltipCell} from 'components/Tooltip'
import classnames from 'classnames'

const infoFields = {
  'email': 'Email',
  'first_name': 'First Name',
  'last_name': 'Last Name',
  'firstName': 'First Name',
  'lastName': 'Last Name',
  'name': 'Name',
  'customerType': 'Customer Type'
}

export default class CustomerIcon extends React.PureComponent {
  static propTypes = {
    isNew: PropTypes.bool,
    className: PropTypes.string,
    info: PropTypes.object
  }

  render() {
    const {isNew, info, className, ...rest} = this.props
    const iconClassName = classnames(className, 'customer-icon')
    const tooltipStyle = info ? 'default' : 'blue'

    return (
      <Icon
        name={isNew ? 'new-customer' : 'customer'}
        width='19px'
        height={isNew ? '14px' : '12px'}
        align={isNew ? null : 'left'}
        className={iconClassName}
        tooltip={this.renderTooltip()}
        tooltipStyle={tooltipStyle}
        {...rest}
      />
    )
  }

  renderTooltip() {
    const {isNew, info} = this.props

    if (info) {
      const customerType = {customerType: isNew ? 'New Customer' : 'Returning customer'}
      const fields = {...customerType, ...info}
      return (
        <TooltipTable>
          {Object.keys(fields).map((key, index) => {
            return (
              <TooltipRow key={index}>
                <TooltipCell>{infoFields[key]}</TooltipCell>
                <TooltipCell color='white'>{fields[key]}</TooltipCell>
              </TooltipRow>
            )
          })}
        </TooltipTable>
      )
    } else if (isNew) {
      return 'New Customer'
    } else {
      return 'Returning customer'
    }
  }
}



// WEBPACK FOOTER //
// ./client/components/CustomerIcon/index.js